var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84615 6.4C5.84615 6.09412 6.09412 5.84615 6.4 5.84615H25.6C25.9059 5.84615 26.1538 6.09412 26.1538 6.4V7.69227H5.84615V6.4ZM4 8.61535V6.4C4 5.07452 5.07452 4 6.4 4H25.6C26.9255 4 28 5.07452 28 6.4V8.61535V25.6C28 26.9255 26.9255 28 25.6 28H6.4C5.07452 28 4 26.9255 4 25.6V8.61535ZM26.1538 9.53843V25.6C26.1538 25.9059 25.9059 26.1538 25.6 26.1538H6.4C6.09412 26.1538 5.84615 25.9059 5.84615 25.6V9.53843H26.1538Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9687 14.3975C20.2756 13.9383 20.8966 13.8149 21.3558 14.1219L24.3132 16.0988C24.3134 16.099 24.3136 16.0991 24.3138 16.0992C24.3139 16.0993 24.3139 16.0993 24.314 16.0993C24.5632 16.2658 24.7352 16.4948 24.8423 16.7261C24.9499 16.9587 25 17.2096 25 17.4532C25 17.6969 24.9499 17.9477 24.8423 18.1804C24.7352 18.4117 24.5632 18.6407 24.314 18.8071C24.3137 18.8073 24.3135 18.8075 24.3132 18.8076L21.3558 20.7846C20.8966 21.0915 20.2756 20.9681 19.9687 20.509C19.6617 20.0498 19.7852 19.4288 20.2443 19.1219L22.7405 17.4532L20.2443 15.7846C19.7852 15.4777 19.6617 14.8566 19.9687 14.3975ZM23.2032 17.1439L23.2025 17.1444L23.2032 17.1439Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0313 14.3975C11.7244 13.9383 11.1034 13.8149 10.6442 14.1219L7.68675 16.0988C7.68657 16.099 7.68638 16.0991 7.68619 16.0992C7.68614 16.0993 7.68608 16.0993 7.68602 16.0993C7.43683 16.2658 7.26477 16.4948 7.15775 16.7261C7.05011 16.9587 6.99997 17.2096 6.99997 17.4532C6.99997 17.6969 7.05011 17.9477 7.15775 18.1804C7.26477 18.4117 7.43683 18.6407 7.68602 18.8071C7.68627 18.8073 7.68651 18.8075 7.68675 18.8076L10.6442 20.7846C11.1034 21.0915 11.7244 20.9681 12.0313 20.509C12.3383 20.0498 12.2148 19.4288 11.7557 19.1219L9.25947 17.4532L11.7557 15.7846C12.2148 15.4777 12.3383 14.8566 12.0313 14.3975ZM8.79676 17.1439L8.79749 17.1444L8.79676 17.1439Z",
    fill: "#121212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3089 11.6508C18.826 11.8447 19.088 12.4212 18.8941 12.9383L14.8941 23.6049C14.7002 24.1221 14.1238 24.3841 13.6067 24.1902C13.0895 23.9962 12.8275 23.4198 13.0215 22.9027L17.0215 12.236C17.2154 11.7189 17.7918 11.4569 18.3089 11.6508Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.75a45b81.svg";
export { ForwardRef as ReactComponent };